<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Cadastrar Usuário
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-10">
                  <form action>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userName">
                            <span class="required">*</span> Nome
                          </label>
                          <input type="text" class="form-control" v-model="users.name" placeholder />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userRG">
                            <span class="required">*</span> Matrícula
                          </label>
                          <input type="text" class="form-control" v-model="users.matriculation" placeholder />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userRG">
                            <span class="required">*</span> RG
                          </label>
                          <input type="text" class="form-control" v-mask="'##.###.###-#'" v-model="users.rg"
                            placeholder />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userCPF">
                            <span class="required">*</span> CPF
                          </label>
                          <input type="text" class="form-control" v-mask="'###.###.###-##'" v-model="users.cpf"
                            placeholder />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userEmail">
                            <span class="required">*</span> E-mail
                          </label>
                          <input type="text" class="form-control" id="userEmail" v-model="users.email" placeholder
                            autocomplete="new-password" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userCellphone">
                            <span class="required">*</span> Celular
                          </label>
                          <input type="text" class="form-control" v-model="users.cellphone" placeholder
                            v-mask="'(##) #####-####'" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDateOfBirth">
                            <span class="required">*</span> Data Nascimento
                          </label>
                          <input type="text" v-mask="'##/##/####'" class="form-control" v-model="users.date_of_birth" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userNumberCNH">
                            <span class="required">*</span> Número da CNH
                          </label>
                          <input type="text" class="form-control" v-mask="'###########'" v-model="users.number_cnh"
                            placeholder />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDateValidityCNH">
                            <span class="required">*</span> Data de Validade da
                            CNH
                          </label>
                          <input type="text" v-mask="'##/##/####'" class="form-control" v-model="users.validity_cnh" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDatePriCNH">
                            <span class="required">*</span> Data Primeira
                            Habilitação
                          </label>
                          <input type="text" v-mask="'##/##/####'" class="form-control" v-model="users.pri_cnh" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userCateg" class="datetimepicker">
                            <span class="required">*</span> Categoria da CNH
                          </label>

                          <multiselect v-model="users.cat_cnh" :multiple="true" :options="options"
                            :close-on-select="true" placeholder="Selecione a categoria..." class="selectCategorias">
                          </multiselect>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDepartment">
                            <span class="required">*</span> Departamento
                          </label>
                          <v-select :options="sortedDepartments" label="description"
                            :reduce="(department) => department.id" class="style-chooser" id="userDepartment"
                            placeholder="Selecione o departamento..." v-model="users.department_id">
                            <div slot="no-options">Nenhum departamento encontrado</div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="userPosition">
                            <span class="required">*</span> Data Admissão
                          </label>
                          <input type="text" v-mask="'##/##/####'" class="form-control"
                            v-model="users.admission_date" />
                        </div>
                      </div>
                      <div class="col-md-4" v-show="$store.state.user.access_nivel == 3">
                        <div class="form-group">
                          <label for="userPosition">
                            <span class="required">*</span> Nível de Acesso
                          </label>
                          <select v-model="users.access_nivel" class="form-control"
                            :disabled="$store.state.user.access_nivel == 4">
                            <option :value="1" :key="1">Usuário Padrão</option>
                            <option :value="2" :key="2">Gestor</option>
                            <option :value="4" :key="4">
                              Administrador de Filial
                            </option>
                            <option :value="3" :key="3">
                              Administrador Master
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-5" v-if="users.access_nivel == 4">
                        <div class="form-group">
                          <label for="branches">
                            <span class="required">*</span> Filial de
                            Administração
                          </label>
                          <v-select :options="branches" label="description" :reduce="(branches) => branches.id"
                            class="style-chooser" id="branches" :disabled="$store.state.user.access_nivel == 4" multiple
                            v-model="users.branch_id">
                            <div slot="no-options">
                              Você pode selecionar múltiplas filiais
                            </div>
                          </v-select>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="branches">
                            <span class="required">*</span> Filiais de Acesso
                          </label>
                          <v-select :options="branches" label="description" :reduce="(branches) => branches.id"
                            class="style-chooser" id="branches" multiple v-model="users.branches_id">
                            <div slot="no-options">
                              Você pode selecionar múltiplas filiais
                            </div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userPassword">
                            <span class="required">*</span> Senha
                          </label>
                          <input type="password" class="form-control" id="userPassword" v-model="users.password"
                            minlength="8" maxlength="32"
                            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,32}$"
                            title="A senha deve ter entre 8 e 32 caracteres e conter letras maiúsculas e minúsculas, números e ao menos 1 caractere especial."
                            placeholder autocomplete="new-password" />

                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userPasswordConfirmation">
                            <span class="required">*</span> Confirme a Senha
                          </label>
                          <input type="password" class="form-control" id="userPasswordConfirmation"
                            v-model="users.password_confirmation" minlength="8" maxlength="32"
                            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,32}$"
                            title="A senha deve ter entre 8 e 32 caracteres e conter letras maiúsculas e minúsculas, números e ao menos 1 caractere especial."
                            placeholder autocomplete="new-password" />
                        </div>


                      </div>
                      <div class="col-md-4" v-if="users.password && users.password.length > 0">
                        <div class="form-group">
                          <ul class="password-rules">
                            <li :class="passwordChecks.length ? 'rule-ok' : 'rule-bad'">
                              <span class="rule-status">{{ passwordChecks.length ? "OK" : "FALTA" }}</span>
                              Entre 8 e 32 caracteres
                            </li>
                            <li :class="passwordChecks.number ? 'rule-ok' : 'rule-bad'">
                              <span class="rule-status">{{ passwordChecks.number ? "OK" : "FALTA" }}</span>
                              Possui números
                            </li>
                            <li :class="passwordChecks.lower ? 'rule-ok' : 'rule-bad'">
                              <span class="rule-status">{{ passwordChecks.lower ? "OK" : "FALTA" }}</span>
                              Possui letras minúsculas
                            </li>
                            <li :class="passwordChecks.upper ? 'rule-ok' : 'rule-bad'">
                              <span class="rule-status">{{ passwordChecks.upper ? "OK" : "FALTA" }}</span>
                              Possui letras maiúsculas
                            </li>
                            <li :class="passwordChecks.special ? 'rule-ok' : 'rule-bad'">
                              <span class="rule-status">{{ passwordChecks.special ? "OK" : "FALTA" }}</span>
                              Possui 1 caractere especial
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="userPic">Foto do Usuário</label>
                          <input type="file" class="form-control" id="userPic" accept="image/*" name="userPic"
                            @change="uploadImage" placeholder />
                        </div>
                      </div>
                    </div>

                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/users" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
                <div class="col-md-2">
                  <div class="circular--landscape">
                    <img v-if="previewImage" :src="previewImage" width="100%" height="198" class="tratament" />
                    <img v-else :src="users.photo" alt width="100%" height="185" class="tratament" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import CtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  name: "imageUpload",
  data() {
    return {
      now: "",
      users: {
        name: "",
        matriculation: "",
        rg: "",
        cpf: "",
        email: "",
        cellphone: "",
        date_of_birth: "",
        cat_cnh: "",
        validity_cnh: "",
        pri_cnh: "",
        number_cnh: "",
        admission_date: "",
        password: "",
        password_confirmation: "",
        branches_id: "",
        access_nivel: "1",
        accpet_terms: "0",
        photo: "",
        department_id: "",
        branch_id: "",
      },
      branches: [],
      departments: [],

      selected: null,
      options: ["A", "B", "C", "D", "E"],

      errors: undefined,

      previewImage: null,
    };
  },
  computed: {
    sortedDepartments() {
      return [...this.departments].sort((a, b) =>
        (a.description || "").localeCompare(b.description || "", "pt-BR", {
          sensitivity: "base",
        })
      );
    },
    passwordChecks() {
      const password = this.users.password || "";
      return {
        length: password.length >= 8 && password.length <= 32,
        number: /[0-9]/.test(password),
        lower: /[a-z]/.test(password),
        upper: /[A-Z]/.test(password),
        special: /[^A-Za-z0-9]/.test(password),
      };
    },
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("userPic");

      fd.append("name", self.users.name);
      fd.append("matriculation", self.users.matriculation);
      fd.append("rg", self.users.rg);
      fd.append("cpf", self.users.cpf);
      fd.append("email", self.users.email);
      fd.append("cellphone", self.users.cellphone);
      fd.append("date_of_birth", self.users.date_of_birth);
      fd.append("cat_cnh", self.users.cat_cnh);
      fd.append("validity_cnh", self.users.validity_cnh);
      fd.append("pri_cnh", self.users.pri_cnh);
      fd.append("number_cnh", self.users.number_cnh);
      fd.append("admission_date", self.users.admission_date);
      fd.append("password", self.users.password);
      fd.append("password_confirmation", self.users.password_confirmation);
      fd.append("branch_id", self.users.branch_id);
      fd.append("branches_id", self.users.branches_id);
      fd.append("access_nivel", self.users.access_nivel);
      fd.append("department_id", self.users.department_id);
      fd.append("accept_terms", 0);
      fd.append("photo", photo.files[0] ? photo.files[0] : "");
      fd.append("_method", "POST");

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "users";

      let fd = self.makeFormData();

      if (self.users.id) {
        api += "/" + self.users.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function (id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
          if (self.users.department_id != null && self.users.department_id !== "") {
            self.users.department_id = Number(self.users.department_id);
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function (id) {
      const self = this;
      const api = self.$store.state.api + "branches/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDepartments: function (id) {
      const self = this;
      const api = self.$store.state.api + "departments/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
  },
  mounted: function () {
    const self = this;

    // Tradução do Multiselect
    $("span").attr("data-select", "Pressione enter para selecionar");
    $("span").attr("data-selected", "Selecionado");
    $("span").attr("data-deselect", "Pressione enter para remover");

    var data = new Date(),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? "0" + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? "0" + mes : mes,
      anoF = data.getFullYear();
    data = anoF + "-" + mesF + "-" + diaF;

    self.now = data.toString();

    self.getBranches();
    self.getDepartments();

    let id = self.$route.params.id;
    if (id) {
      self.getUsers(id);
    }
  },
  components: {
    BaseCrud,
    Multiselect,
    CtkDateTimePicker,
    vSelect,
  },
};
</script>
<style>
.uploading-image {
  display: flex;
}

.password-rules {
  margin: 8px 0 0 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
}

.password-rules li {
  display: flex;
  gap: 8px;
  align-items: center;
}

.rule-status {
  font-weight: bold;
  min-width: 44px;
  text-align: center;
  padding: 1px 6px;
  border-radius: 4px;
  border: 1px solid transparent;
}

.rule-ok {
  color: #1b5e20;
}

.rule-ok .rule-status {
  background: #e6f4ea;
  border-color: #1b5e20;
}

.rule-bad {
  color: #8b1a1a;
}

.rule-bad .rule-status {
  background: #fdecea;
  border-color: #8b1a1a;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Add.vue